import OAuth2 from './OAuth2';

export default OAuth2;
